<template>
  <DSSheet v-model:open="isOpen">
    <DSSheetContent
      side="bottom"
      class="flex max-h-[78vh] flex-col gap-0 p-0"
    >
      <DSSheetHeader class="flex-none flex-row items-center justify-between gap-2 border-b border-border p-4 text-left">
        <DSSheetTitle class="text-lg">
          Fields
        </DSSheetTitle>
      </DSSheetHeader>
      <div class="flex flex-1 flex-col gap-5 overflow-y-auto p-4">
        <PivotFieldsSections
          v-model="config"
          :readonly
          :disable-cols
        />
      </div>
    </DSSheetContent>
  </DSSheet>
</template>

<script setup lang="ts">
import { DSSheet, DSSheetContent, DSSheetHeader, DSSheetTitle } from '@ds'

import PivotFieldsSections from './PivotFieldsSections.vue'
import { PivotTableConfig } from '@types'

interface PivotFieldsSheetProps {
  readonly?: boolean
  disableCols?: boolean
}

defineProps<PivotFieldsSheetProps>()

const isOpen = defineModel<boolean>('open')
const config = defineModel<PivotTableConfig>('config')
</script>
